import { Link } from "react-router-dom";

const LinkCard = (props) => {
  const styles = {
    linkButon: {
      backgroundColor: "#000",
      border: `2px solid ${props.color}`,
      visibility: "hidden",
    },
  };
  return (
    <Link
      to={{ pathname: props.link }}
      rel="noreferrer"
      target={props.newTab ? "_blank" : ""}
    >
      <div
        className="w-full flex flex-row p-4 mt-4 rounded-md cursor-pointer link-card"
        style={styles.linkButon}
      >
        <div>{props.title}</div>
        <div className="content-end ml-auto" style={{ color: props.color }}>
          ➔
        </div>
      </div>
    </Link>
  );
};

export default LinkCard;
